import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useState } from 'react';
import { useCache } from '../cache';
import { useCheckOnlineStatus } from '../hooks';
const defaultState = {
    isOnline: true,
    cachedData: {},
    currentPage: null,
};
export const CommonContext = createContext(defaultState);
export const CommonContextProvider = ({ children }) => {
    const { isOnline } = useCheckOnlineStatus();
    const { cachedData, getCachedImage } = useCache();
    const [currentPage, setCurrentPage] = useState(null);
    return (_jsx(CommonContext.Provider, { value: {
            currentPage: currentPage,
            setCurrentPage: setCurrentPage,
            isOnline: isOnline,
            cachedData: cachedData,
            getCachedImage,
        }, children: children }));
};
